import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown } from '../shared';
import { selectLang } from '../../store/ui/ui.selector';
import { selectTaxonomyGroups } from '../../store/utils/utils.selector';
import { translate } from '../../lib/lang.helper';
import { sendSingleRequest } from '../../apis';
import { loadTaxonomyGroups } from '../../store/utils/utils.actions';
import ModalUtil from '../farm-util/ModalUtil';

interface Props {
  value: number[];
  onChange: (ids: number[]) => void;
  className?: string;
  disabled?: boolean;
}

const TaxonomyGroupsForm = ({
  value,
  onChange,
  className,
  disabled,
}: Props) => {
  const dispatch = useDispatch<any>();
  const lang = useSelector(selectLang);
  const taxonomyGroups = useSelector(selectTaxonomyGroups);

  const [modalVisible, setModalVisible] = useState(false);
  const [adding, setAdding] = useState(false);

  const handleCreate = async (form: { name: string }) => {
    const name = form.name.trim();
    if (!name) return;
    setAdding(true);
    const res = await sendSingleRequest(
      { name },
      'POST',
      'api/account/taxonomy_group',
      true,
    );
    if (res.status) {
      await dispatch(loadTaxonomyGroups());
      if (res.data?.id) {
        onChange([...value, res.data.id]);
      }
      setModalVisible(false);
    }
    setAdding(false);
  };

  return (
    <div className={className}>
      <div className='d-flex align-end justify-between mb-4'>
        <label className='dropdown__label'>
          {translate(lang, 'Taxonomy groups')}
        </label>
        {!disabled && (
          <Button
            width='small'
            size={3}
            type='transparent'
            color='blue'
            onClick={() => setModalVisible(true)}
          >
            {translate(lang, '+ Add new')}
          </Button>
        )}
      </div>
      {taxonomyGroups.length > 0 && (
        <Dropdown
          mode='multiple'
          placeholder={translate(lang, '_sel_taxonomy_groups')}
          options={taxonomyGroups.map(x => ({
            id: x.id.toString(),
            value: x.id.toString(),
            label: x.name,
          }))}
          value={value.map(String) as any}
          onChange={(vals: any) => onChange((vals as string[]).map(Number))}
          disabled={disabled}
        />
      )}
      {modalVisible && (
        <ModalUtil
          visible={modalVisible}
          type='create'
          title={translate(lang, 'Add taxonomy group')}
          data={{ name: '' }}
          onCancel={() => setModalVisible(false)}
          onConfirm={handleCreate}
          disabled={adding}
        />
      )}
    </div>
  );
};

export default TaxonomyGroupsForm;
